"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SITE_ACTIVITY: "@@data-and-alert-site/site-activity",
  SITE_NOTIFICATION: "@@data-and-alert-site/site-notification",
  SITE_ADD_NOTIFICATION: "@@data-and-alert-site/add-site-notification",
  SITE_UPDATE_NOTIFICATION: "@@data-and-alert-site/update-site-notification",
  RESET: "@@data-and-alert-site/reset",
  SUCCESS: "@@data-and-alert-site/success",
  ERROR: "@@data-and-alert-site/error"
};
exports.actionTypes = actionTypes;